<script setup lang="ts">
import { useTemplateRef } from "vue";

import hot from "@/assets/reactions/reaction-hot.svg";
import increment from "@/assets/reactions/reaction-increment.svg";
import love from "@/assets/reactions/reaction-love.svg";
import type { Reaction } from "@/model/card";

defineProps<{ reaction: Reaction }>();

const rootRef = useTemplateRef("root");
defineExpose({ rootRef });

const image: Record<Reaction, string> = { hot, increment, love };

const label: Record<Reaction, string> = {
  hot: /*$t*/ "label.reaction.hot",
  increment: /*$t*/ "label.reaction.increment",
  love: /*$t*/ "label.reaction.love",
};
</script>

<template>
  <img ref="root" :src="image[reaction]" :alt="$t(label[reaction])" />
</template>

<style lang="scss" scoped>
@use "@/styles/board";

img {
  height: board.len(40px);
}
</style>
